export default __webpack_public_path__ + "static/media/Livingroom-Interior-Architecture-EschweilerPhotography_MG_093022_AS.14d2ecf1.jpg";